/*eslint-disable*/
import { Flex, SquareIcon } from 'styling/GlobalStyles'
import { GlobalViewWidget, GlobalViewWidgetContent, GloblViewWidgetTitle, WidgetBar, WidgetBarContainer, WidgetBarInfoContainer } from '../GlobalView.styled'
import { employeesIcon } from 'assets/icons/EmployeesIcon'
import { BodyText, OtherText, ParagraphText } from 'styling/Typography'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import { useEffect, useMemo } from 'react'
import { getWorkerAvailability } from 'features/globalView/globalViewSlice'

export const GLEmployeesWidget = ({ handleWidget, selectedStatus }: { selectedStatus: string, handleWidget: (open: boolean, type: string) => void }) => {
    const colors = ['#02CB42', '#ff9900', '#FF4F46', '#1CBBFF']
    const { workersAvailability } = useSelector((state: RootState) => state.globalView)
    const dispatch = useDispatch<AppDispatch>()
    const style = closed ? { transform: 'translateX(-100%)', opacity: 0 } : {}


    useEffect(() => {
        dispatch(getWorkerAvailability()) // TODO: Videti da li da se premesta
    }, [])

    const allWorkers = useMemo(() => (workersAvailability?.free || 0) + (workersAvailability?.busy || 0) + (workersAvailability?.absent || 0), [workersAvailability])

    const getPercentage = (curr: number): string => {
        if (!curr || curr === 0) return '10%';
        return ((curr / allWorkers) * 100).toString() + '%'
    }

    return <GlobalViewWidget style={style} >
        <GloblViewWidgetTitle>
            <SquareIcon color='#ff9900' >
                {employeesIcon}
            </SquareIcon>
            <Flex column >
                <BodyText weight='bold' >Employees</BodyText>
                <OtherText style={{ color: '#ff9900', cursor: 'pointer', width: 'max-content' }} onClick={() => handleWidget(true, null)}  > View All </OtherText>
            </Flex>
        </GloblViewWidgetTitle>

        <GlobalViewWidgetContent>
            <WidgetBarContainer selected={selectedStatus == 'Free'} onClick={() => handleWidget(true, 'Free')} >
                <WidgetBarInfoContainer  >
                    <BodyText>Free</BodyText>
                    <Flex gap='1rem' >
                        <WidgetBar width={getPercentage(workersAvailability?.free)} color={colors[0]} />
                        <ParagraphText>{workersAvailability?.free}</ParagraphText>
                    </Flex>

                </WidgetBarInfoContainer>
            </WidgetBarContainer>
            <WidgetBarContainer selected={selectedStatus == 'Busy'} onClick={() => handleWidget(true, 'Busy')} >
                <WidgetBarInfoContainer>
                    <BodyText>Busy</BodyText>
                    <Flex gap='1rem' >
                        <WidgetBar width={getPercentage(workersAvailability?.busy)} color={colors[1]} />
                        <ParagraphText>{workersAvailability?.busy}</ParagraphText>
                    </Flex>

                </WidgetBarInfoContainer>
            </WidgetBarContainer>
            <WidgetBarContainer selected={selectedStatus == 'Absent'} onClick={() => handleWidget(true, 'Absent')} >
                <WidgetBarInfoContainer>
                    <BodyText>Absent</BodyText>
                    <Flex gap='1rem' >
                        <WidgetBar width={getPercentage(workersAvailability?.absent)} color={colors[2]} />
                        <ParagraphText>{workersAvailability?.absent}</ParagraphText>
                    </Flex>

                </WidgetBarInfoContainer>
            </WidgetBarContainer>

        </GlobalViewWidgetContent>
    </GlobalViewWidget>
}
